export const realEstateFields = (attrs) => {
  const propertyType = attrs?.propertyType || "";

  const common = [
    {
      name: "propertyType",
      label: "Тип нерухомості",
      type: "select",
      options: ["Квартира", "Будинок", "Таунхаус", "Ділянка", "Комерція", "Гараж"],
      required: true,
    },
    { name: "titleOnPlan", label: "Назва ЖК / Назва об’єкта", type: "text" },
    { name: "area", label: "Площа (м²)", type: "number" },
    {
      name: "utilities",
      label: "Комунікації",
      type: "multiselect",
      options: ["Вода", "Газ", "Електрика", "Каналізація", "Інтернет / Оптоволокно"],
    },
    {
      name: "heating",
      label: "Опалення",
      type: "select",
      options: ["Індивідуальне", "Центральне", "Електрика", "Твердопаливне", "Без опалення"],
    },
    {
      name: "condition",
      label: "Стан",
      type: "select",
      options: [
        "Новобудова",
        "Вторинне",
        "Після будівельників",
        "Косметичний ремонт",
        "Капітальний ремонт",
        "Потребує ремонту",
      ],
    },
    { name: "ceilingHeight", label: "Висота стель (м)", type: "number", step: "0.01" },
    { name: "bathrooms", label: "С/вузлів", type: "number" },
    { name: "furniture", label: "Меблі", type: "select", options: ["Немає", "Частково", "Повністю"] },
    { name: "appliances", label: "Техніка", type: "select", options: ["Немає", "Частково", "Повністю"] },
    { name: "security", label: "Безпека", type: "select", options: ["Домофон", "Охорона", "Відеонагляд", "Сигналізація", "Немає"] },
    { name: "parking", label: "Паркування", type: "select", options: ["Немає", "Двір", "Підземне", "Паркомісце", "Гараж"] },
    { name: "extras", label: "Додатково (сауна, камін, тераса…)", type: "text" },
  ];

  const apartment = [
    { name: "rooms", label: "Кількість кімнат", type: "number" },
    { name: "floor", label: "Поверх", type: "number" },
    { name: "floorsTotal", label: "Загальна кількість поверхів", type: "number" },
    { name: "balcony", label: "Балкон / Лоджія", type: "select", options: ["Немає", "Балкон", "Лоджія", "Кілька"] },
    { name: "layout", label: "Планування", type: "select", options: ["Студія", "Роздільні", "Суміжні", "Кухня-вітальня"] },
    { name: "wallType", label: "Тип стін", type: "select", options: ["Цегла", "Панель", "Моноліт", "Керамоблок", "Інше"] },
    { name: "lift", label: "Ліфт", type: "select", options: ["Немає", "Пасажирський", "Вантажний", "Обидва"] },
  ];

  const house = [
    { name: "rooms", label: "Кількість кімнат", type: "number" },
    { name: "floorsTotal", label: "Кількість поверхів у будинку", type: "number" },
    { name: "plotArea", label: "Площа ділянки (сотки)", type: "number" },
    { name: "garage", label: "Гараж / Паркомісце", type: "select", options: ["Немає", "Гараж", "Навіс", "Паркомісце"] },
    { name: "wallType", label: "Матеріал стін", type: "select", options: ["Цегла", "Газоблок", "Дерево", "Панель", "Моноліт", "Інше"] },
    { name: "roof", label: "Покрівля", type: "select", options: ["Металочерепиця", "Бітум", "Профнастил", "Черепиця", "Інше"] },
    { name: "basement", label: "Підвал", type: "select", options: ["Немає", "Є"] },
    { name: "attic", label: "Мансарда / Горище", type: "select", options: ["Немає", "Мансарда", "Горище"] },
    { name: "outbuildings", label: "Госп. споруди", type: "text", placeholder: "Сарай, альтанка, літня кухня…" },
  ];

  const townhouse = [
    { name: "rooms", label: "Кількість кімнат", type: "number" },
    { name: "floorsTotal", label: "Кількість поверхів", type: "number" },
    { name: "plotArea", label: "Площа прибудинкової ділянки (сотки)", type: "number" },
    { name: "garage", label: "Гараж / Паркомісце", type: "select", options: ["Немає", "Гараж", "Навіс", "Паркомісце"] },
    { name: "wallType", label: "Матеріал стін", type: "select", options: ["Цегла", "Газоблок", "Дерево", "Панель", "Моноліт", "Інше"] },
    { name: "entrances", label: "Окремий вхід", type: "select", options: ["Так", "Ні"] },
  ];

  const land = [
    { name: "landPurpose", label: "Цільове призначення", type: "select", options: ["Житлове", "С/Г", "Комерційне", "Інше"] },
    { name: "plotArea", label: "Площа ділянки (сотки)", type: "number" },
    { name: "frontage", label: "Фасад (м)", type: "number" },
    { name: "access", label: "Під'їзд", type: "select", options: ["Асфальт", "Грунтова дорога"] },
    { name: "relief", label: "Рельєф", type: "select", options: ["Рівний", "Похилий", "Інше"] },
  ];

  const commercial = [
    { name: "commercialType", label: "Тип комерції", type: "select", options: ["Офіс", "Магазин", "Склад", "Виробництво", "Готель", "Ресторан", "Кафе", "Салон краси", "Інше"] },
    { name: "floor", label: "Поверх", type: "number" },
    { name: "entrance", label: "Вхід", type: "select", options: ["З вулиці", "З двору", "Спільний"] },
    { name: "ceilingType", label: "Промислові стелі", type: "select", options: ["Немає", "Так"] },
    { name: "loadingAccess", label: "Під'їзд для вантажівок", type: "select", options: ["Немає", "Є"] },
  ];

  const garage = [
    { name: "garageType", label: "Тип гаража", type: "select", options: ["Бокс", "Капітальний", "Металевий", "Стоянка / Паркомісце"] },
    { name: "security", label: "Охорона", type: "select", options: ["Немає", "Охорона / Сигналізація"] },
    { name: "pit", label: "Оглядова яма", type: "select", options: ["Немає", "Є"] },
  ];

  switch (propertyType) {
    case "Квартира":
      return [...common, ...apartment];
    case "Будинок":
      return [...common, ...house];
    case "Таунхаус":
      return [...common, ...townhouse];
    case "Ділянка":
      return [
        { name: "propertyType", label: "Тип нерухомості", type: "select", options: ["Квартира", "Будинок", "Таунхаус", "Ділянка", "Комерція", "Гараж"], required: true },
        ...land,
      ];
    case "Комерція":
      return [...common, ...commercial];
    case "Гараж":
      return [
        { name: "propertyType", label: "Тип нерухомості", type: "select", options: ["Квартира", "Будинок", "Таунхаус", "Ділянка", "Комерція", "Гараж"], required: true },
        { name: "area", label: "Площа (м²)", type: "number" },
        ...garage,
      ];
    default:
      return common;
  }
};
